import React, { useState, useEffect } from "react"
import { Form, Select, Row, Modal, Col, InputNumber, Spin } from "antd"
import * as Http from "utils/http.helper"
import toastr from "toastr"
import Sounds from "utils/sounds"

import "toastr/build/toastr.min.css"
const { Option } = Select
const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
}
const product = [
  { value: 1, label: "Apparel" },
  { value: 2, label: "Engraving" },
  { value: 3, label: "Deri" },
  { value: 4, label: "Uvdtf" },
  { value: 5, label: "Package" },
]

const UpsertModal = ({
  upsertModal,
  setUpsertModal,
  loading,
  setLoading,
  customersList,
  getData,
}) => {
  const [form] = Form.useForm()
  const [styles, setStyles] = useState([])
  const [options, setOptions] = useState([])
  const [sizes, setSizes] = useState([])
  const [colors, setColors] = useState([])

  const getStyles = () => {
    setLoading(true)
    Http.get(`api/orders/GetAllPrintProperties`)
      .then(res => {
        if (res?.success) {
          setOptions(res.data)
          let styleList = res.data.map(item => ({
            value: item.styleId,
            label: item.styleName,
          }))
          styleList.sort((a, b) => a.label.localeCompare(b.label))
          setStyles(styleList)
          let sizeList = res.data.map(item => ({
            value: item.styleId,
            label: item.styleName,
          }))
          sizeList.sort((a, b) => a.label.localeCompare(b.label))
          setSizes(sizeList)
          let colorList = res.data.map(item => ({
            value: item.styleId,
            label: item.styleName,
          }))
          colorList.sort((a, b) => a.label.localeCompare(b.label))
          setColors(colorList)

          if (upsertModal?.data?.id) {
            handleChangeStyle(upsertModal?.data?.styleId, res.data)
          }
          setLoading(false)
        }
      })
      .catch(error => {
        setLoading(false)
        toastr.error(error.response.data.Message)
      })
  }

  const handleChangeStyle = (val, data) => {
    setLoading(true)
    let filter = []
    if (options.length > 0) {
      filter = options.filter(x => x.styleId === val)
    } else {
      filter = data.filter(x => x.styleId === val)
    }

    if (filter.length > 0) {
      let arrSizes = filter[0].sizes.map(item => ({
        value: item.id,
        label: item.name,
      }))
      arrSizes.sort((a, b) => {
        const aIsMonth = a.label.includes("Month")
        const bIsMonth = b.label.includes("Month")
        if (!aIsMonth && bIsMonth) return 1
        if (aIsMonth && !bIsMonth) return -1
        return a.label.localeCompare(b.label)
      })
      setSizes(arrSizes)

      let arrColors = filter[0].colors.map(item => ({
        value: item.id,
        label: item.name,
      }))
      arrColors.sort((a, b) => a.label.localeCompare(b.label))
      setColors(arrColors)
    }

    setLoading(false)
  }

  useEffect(() => {
    getStyles()
  }, [])

  const onFinish = values => {
    setLoading(true)
    const obj = {
      companyId: values.companyId,
      price: values.price,
      sizeId: values.sizeId,
      colorId: values?.colorId || null,
      styleId: values.styleId,
      categoryId: "7",
    }

    Http.post("api/accounting/setCompanyPrintProductPrice", obj)
      .then(res => {
        if (res.success) {
          Sounds.success()
          toastr.success(`Process Success.`)
          setUpsertModal({ show: false, data: null, companyId: null })
          getData()
          setLoading(false)
        } else {
          Sounds.error()
          setLoading(false)
          toastr.error(`Process Fail.`)
        }
      })
      .catch(error => {
        Sounds.error()
        setLoading(false)
        toastr.error(error.response.data.title)
      })
  }

  useEffect(() => {
    if (upsertModal.data?.id) {
      form.setFieldsValue({
        companyId: upsertModal.data.companyId,
        styleId: upsertModal.data.styleId,
        sizeId: upsertModal.data.sizeId,
        colorId: upsertModal.data.colorId,
        price: upsertModal.data.price,
      })
    }
    if (upsertModal?.companyId) {
      form.setFieldsValue({ companyId: upsertModal.companyId })
    }
  }, [upsertModal])

  return (
    <Modal
      title={upsertModal.data?.id ? "Price Update" : "Add New Price"}
      centered
      maskClosable={false}
      open={upsertModal.show}
      cancelText="Close"
      okText={upsertModal.data?.id ? "Update" : "Save"}
      onOk={() => {
        form.validateFields().then(val => onFinish(val)).catch(() => {})
      }}
      onCancel={() =>
        setUpsertModal({ show: false, data: null, companyId: null })
      }
      width={600}
      confirmLoading={loading}
    >
      <Spin spinning={loading}>
        <Row style={{ marginTop: 25 }}>
          <Col span={24}>
            <Form {...layout} form={form}>
              <Form.Item
                label="Company"
                name="companyId"
                rules={[{ required: true, message: "This field is required!" }]}
              >
                <Select
                  allowClear
                  placeholder="Select a company"
                  style={{ minWidth: "150px" }}
                  disabled={upsertModal?.data?.companyId}
                >
                  {customersList.map(item => (
                    <Option value={item.value} key={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="styleId"
                label="Style"
                rules={[{ required: true, message: "This field is required!" }]}
              >
                <Select
                  allowClear
                  onChange={e => handleChangeStyle(e)}
                  options={styles}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>

              <Form.Item
                name="sizeId"
                label="Size"
                rules={[{ required: true, message: "This field is required!" }]}
              >
                <Select
                  allowClear
                  options={sizes}
                  disabled={sizes.length === 0}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>

              <Form.Item
                name="colorId"
                label="Color"
                rules={[{ required: colors.length !== 0, message: "This field is required!" }]}
              >
                <Select
                  allowClear
                  options={colors}
                  disabled={colors.length === 0}
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>

              <Form.Item
                name="price"
                label="Price"
                rules={[{ required: true, message: "This field is required!" }]}
              >
                <InputNumber
                  formatter={value =>
                    `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={value => value.replace(/\$\s?|(,*)/g, "")}
                  min={0}
                  step={0.01}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Spin>
    </Modal>
  )
}

export default UpsertModal
